import React from 'react';

export const SourceTypeBoolean = (props: { size: number } = { size: 24 }) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="new-Icon/source_boolean"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="sourceBoolean">
        <rect
          id="bck-SorceDataType"
          fill="#575757"
          x="0"
          y="0"
          width="32"
          height="32"
          rx="2"
        ></rect>
        <path
          d="M8,23.3333333 L8,8 L11.2088015,8 C11.9123006,8 12.5117016,8.10767683 13.0070225,8.32303371 C13.5023433,8.53839059 13.907926,8.82552879 14.2237828,9.18445693 C14.5396395,9.54338507 14.7657609,9.95614623 14.9021536,10.4227528 C15.0385463,10.8893594 15.1067416,11.3739051 15.1067416,11.8764045 L15.1067416,12.4363296 C15.1067416,12.8526862 15.0744385,13.2044305 15.0098315,13.491573 C14.9452244,13.7787155 14.8483153,14.0299615 14.7191011,14.2453184 C14.47503,14.6473179 14.1017503,14.9918837 13.5992509,15.2790262 C14.1161075,15.5230974 14.4965656,15.8820201 14.7406367,16.3558052 C14.9847078,16.8295904 15.1067416,17.4756513 15.1067416,18.2940075 L15.1067416,19.1554307 C15.1067416,20.5050005 14.7801219,21.538698 14.1268727,22.2565543 C13.4736235,22.9744106 12.4291582,23.3333333 10.9934457,23.3333333 L8,23.3333333 Z M10.1966292,16.2265918 L10.1966292,21.1367041 L11.1441948,21.1367041 C11.5892656,21.1367041 11.9374207,21.072098 12.1886704,20.9428839 C12.4399201,20.8136698 12.6301492,20.6342084 12.7593633,20.4044944 C12.8885768,20.1747804 12.9675404,19.9019991 12.9962547,19.5861423 C13.0249689,19.2702856 13.0393258,18.9257197 13.0393258,18.5524345 C13.0393258,18.1647921 13.0177905,17.8274047 12.9747191,17.5402622 C12.9316477,17.2531197 12.8455063,17.0090522 12.7162921,16.8080524 C12.5727209,16.6070527 12.3789026,16.4598943 12.1348315,16.366573 C11.8907603,16.2732517 11.5677299,16.2265918 11.1657303,16.2265918 L10.1966292,16.2265918 Z M10.1966292,10.0674157 L10.1966292,14.2883895 L11.1872659,14.2883895 C11.9194793,14.2883895 12.4112035,14.1053371 12.6624532,13.7392322 C12.9137029,13.3731255 13.0393258,12.8383306 13.0393258,12.1348315 C13.0393258,11.4456894 12.899346,10.9288407 12.619382,10.5842697 C12.3394181,10.2396987 11.833337,10.0674157 11.1011236,10.0674157 L10.1966292,10.0674157 Z M17.1741573,23.3333333 L17.1741573,8 L19.3707865,8 L19.3707865,21.1367041 L23.7209738,21.1367041 L23.7209738,23.3333333 L17.1741573,23.3333333 Z"
          id="BL"
          fill="#FFFFFF"
          fill-rule="nonzero"
        ></path>
      </g>
    </g>
  </svg>
);
